import { InputHTMLAttributes } from 'react';
import cx from 'classnames';

type Props = InputHTMLAttributes<HTMLInputElement>;
export const Input = (props: Props) => {
  return <input {...props} className={cx('vmm-input')} />;
};
